import React from 'react';
import {ShowIf} from 'components/utils';
import {User} from 'api';
import {connect} from 'react-redux';

class FavoriteButton extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isFavorited: false,
      isLoading: false
    };
    this.onFavorite = this.onFavorite.bind(this);
    this.unFavorite = this.unFavorite.bind(this);
  }

  componentDidMount() {
    if (this.props.user) {
      this.setState({isLoading: true});
      User.actions.hasFavorite.request({id: this.props.user.id, fk: this.props.productId}).then(response => {
        this.setState({isLoading: false, isFavorited: true});
      }).catch(() => {
        this.setState({isLoading: false});
      });
    }
  }

  onFavorite() {
    this.setState({isLoading: true});
    User.actions.favorite.request({id: this.props.productId}).then(response => {
      this.setState({isLoading: false, isFavorited: true});
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  unFavorite() {
    this.setState({isLoading: true});
    User.actions.unFavorite.request({id: this.props.productId}).then(response => {
      this.setState({isLoading: false, isFavorited: false});
    }).catch(() => {
      this.setState({isLoading: false});
    });
  }

  render() {
    const {isFavorited, isLoading} = this.state;
    return (
      <div className="favorite-button">
        <ShowIf condition={this.props.user && !isFavorited}>
          <button type="button" disabled={isLoading} className="button-white" onClick={this.onFavorite}><span className="fa fa-heart-o"></span>Yêu thích</button>
        </ShowIf>
        <ShowIf condition={this.props.user && isFavorited}>
          <button type="button" disabled={isLoading} className="button-white" onClick={this.unFavorite}><span className="fa fa-heart-o"></span>Huỷ yêu thích</button>
        </ShowIf>
      </div>
    );
  }
}

const mapStateToProp = (state) => {
  return {
    user: state.auth.user
  };
};

export default connect(mapStateToProp)(FavoriteButton);



// WEBPACK FOOTER //
// ./components/partials/favorite-button/favorite-button.jsx